import { createContext, useCallback, useContext, useMemo, useState, ReactNode } from 'react';

interface ToastContextValue {
  notify: (message: string) => void;
}

const ToastContext = createContext<ToastContextValue | null>(null);

/** Avisos efímeros, como el toast del mockup del portal. */
export function ToastProvider({ children }: { children: ReactNode }) {
  const [message, setMessage] = useState<string | null>(null);

  const notify = useCallback((text: string) => {
    setMessage(text);
    window.setTimeout(() => setMessage((current) => (current === text ? null : current)), 2600);
  }, []);

  const value = useMemo(() => ({ notify }), [notify]);

  return (
    <ToastContext.Provider value={value}>
      {children}
      <div
        role="status"
        aria-live="polite"
        style={{
          position: 'fixed',
          left: '50%',
          bottom: message ? 'var(--space-5)' : '-100px',
          transform: 'translateX(-50%)',
          background: 'var(--plum)',
          color: '#fff',
          padding: '10px 18px',
          borderRadius: 999,
          fontSize: 'var(--text-md)',
          boxShadow: 'var(--shadow)',
          transition: 'bottom .25s ease, opacity .25s ease',
          opacity: message ? 1 : 0,
          pointerEvents: 'none',
          zIndex: 100,
        }}
      >
        {message}
      </div>
    </ToastContext.Provider>
  );
}

export function useToast() {
  const context = useContext(ToastContext);
  if (!context) throw new Error('useToast debe usarse dentro de ToastProvider');
  return context;
}
